
export function scrollContentAreaToElement(
  el: Element | null,
  options?: { behavior?: ScrollBehavior; extraGapPx?: number }
): void {
  if (!el) return;

  const container = document.querySelector<HTMLElement>(".content-area");
  if (!container) {
    (el as HTMLElement).scrollIntoView?.({
      behavior: options?.behavior ?? "smooth",
      block: "start",
    });
    return;
  }

  const gap = options?.extraGapPx ?? 8;
  const tabs = document.querySelector<HTMLElement>("[data-merit-ic-below]");
  const reserve =
    (tabs?.getBoundingClientRect().height ?? 0) + gap;

  const targetTop =
    el.getBoundingClientRect().top -
    container.getBoundingClientRect().top +
    container.scrollTop;

  const top = Math.max(0, targetTop - reserve);
  container.scrollTo({ top, behavior: options?.behavior ?? "smooth" });
}
